// Forçar exibição de notificação para debug
export const forceShowNotification = async () => {
  if (!('Notification' in window)) {
    alert('❌ Este navegador não suporta notificações!');
    return false;
  }

  // Verificar permissão
  let permission = Notification.permission;
  console.log('Permissão atual:', permission);

  if (permission === 'default') {
    permission = await Notification.requestPermission();
    console.log('Nova permissão:', permission);
  }

  if (permission !== 'granted') {
    const message = `❌ Permissão negada! Status: ${permission}\n\n` +
      `Para corrigir:\n` +
      `1. Clique no cadeado 🔒 na barra de endereços\n` +
      `2. Vá em "Notificações"\n` +
      `3. Mude para "Permitir"\n` +
      `4. Recarregue a página\n\n` +
      `Ou acesse: chrome://settings/content/notifications`;
    alert(message);
    return false;
  }

  // Testar notificação direta
  try {
    console.log('Criando notificação direta...');
    const notification = new Notification('🔔 Teste Forçado', {
      body: 'Esta é uma notificação de teste direta. Se você vê isso, a API funciona!',
      icon: '/android-chrome-192x192.png',
      badge: '/favicon-32x32.png',
      tag: 'force-test',
      requireInteraction: false,
      silent: false
    });

    console.log('Notificação criada:', notification);

    let shown = false;
    let errored = false;

    notification.onshow = () => {
      shown = true;
      console.log('✅ Notificação EXIBIDA na tela!');
      alert('✅ Notificação apareceu na tela! A API funciona.');
    };

    notification.onerror = (error) => {
      errored = true;
      console.error('❌ Erro ao exibir notificação:', error);
      alert('❌ Erro ao exibir notificação: ' + JSON.stringify(error));
    };

    notification.onclose = () => {
      console.log('Notificação fechada');
      if (!shown && !errored) {
        console.warn('⚠️ Notificação foi fechada antes de ser exibida');
      }
    };

    // Aguardar um pouco para ver se aparece
    setTimeout(() => {
      if (!shown && !errored) {
        console.warn('⚠️ Notificação não foi exibida após 2 segundos');
        alert('⚠️ Notificação criada mas não apareceu na tela.\n\n' +
          'Possíveis causas:\n' +
          '1. Windows bloqueando notificações\n' +
          '2. Modo "Não Perturbe" ativado\n' +
          '3. Janela do navegador em foco (minimize para testar)');
      }
    }, 2000);

    // Fechar após 10 segundos
    setTimeout(() => {
      notification.close();
    }, 10000);

    return true;
  } catch (error) {
    console.error('❌ Erro ao criar notificação:', error);
    alert('❌ Erro: ' + error.message);
    return false;
  }
};

// Testar via Service Worker
export const forceShowSWNotification = async () => {
  if (!('serviceWorker' in navigator)) {
    alert('❌ Service Worker não suportado!');
    return false;
  }

  try {
    const registration = await navigator.serviceWorker.ready;
    console.log('Service Worker pronto:', registration);

    const result = await registration.showNotification('🔔 Teste via SW', {
      body: 'Esta é uma notificação via Service Worker. Se você vê isso, o SW funciona!',
      icon: '/android-chrome-192x192.png',
      badge: '/favicon-32x32.png',
      tag: 'force-sw-test',
      requireInteraction: false,
      silent: false,
      vibrate: [200, 100, 200]
    });

    console.log('✅ Notificação via SW criada:', result);
    
    // Verificar se apareceu
    setTimeout(async () => {
      const notifications = await registration.getNotifications({ tag: 'force-sw-test' });
      if (notifications.length > 0) {
        console.log('✅ Notificação encontrada:', notifications.length);
        alert('✅ Notificação via Service Worker apareceu!');
      } else {
        console.warn('⚠️ Notificação não encontrada após criação');
        alert('⚠️ Notificação criada mas não apareceu.\n\nVerifique permissões do navegador/Windows.');
      }
    }, 2000);

    return true;
  } catch (error) {
    console.error('❌ Erro ao criar notificação via SW:', error);
    alert('❌ Erro: ' + error.message);
    return false;
  }
};

